export enum ProductKind {
	EXPRESS = 3,
	NONAME = 6,
	OBJECTNONAME = 5,
	ROUNDTRIP = 2,
	TRANSPORT = 4,
	VACATION = 1,
}
